<template>
  <div>
    <!-- Show BillingSidePanel when status is billing -->
    <BillingSidePanel
      v-if="status === 'billing'"
      :userName="userName"
      :userProfilePicture="userProfilePicture"
      :availablePoints="availablePoints"
      :key="userName + availablePoints"
    />

    <img
      v-else-if="currentImage"
      :src="currentImage"
      :style="{ width: imageWidth, height: imageHeight }"
    />
    <WelcomePage v-else :width="width" :height="height" />
  </div>
</template>

<script>
import WelcomePage from "@/components/WelcomePage.vue";
import BillingSidePanel from "@/components/BillingSidePanel.vue";
import { EventBus } from "@/eventBus";
import { globalState } from "@/store/globalState"; // Import global state
import { watch, onMounted } from "vue";

export default {
  components: {
    WelcomePage,
    BillingSidePanel,
  },
  props: {
    width: {
      type: String,
      default: "100dvw",
    },
    height: {
      type: String,
      default: "100dvh",
    },
    status: {
      type: String,
      default: "idle",
    },
  },
  setup(props, { emit }) {
    // Use globalState for persistent user details
    const { userName, userProfilePicture, availablePoints } = globalState;

    // Listen for user details updates via EventBus
    onMounted(() => {
      EventBus.on("user-details-received", (userDetails) => {
        console.log("User details received:", userDetails);

        globalState.userName = userDetails.userName || "User";
        globalState.userProfilePicture = userDetails.userProfilePicture || "";
        globalState.availablePoints = userDetails.availablePoints || 0;

        console.log("Updated globalState.userName:", globalState.userName);
        console.log(
          "Updated globalState.userProfilePicture:",
          globalState.userProfilePicture
        );
        console.log(
          "Updated globalState.availablePoints:",
          globalState.availablePoints
        );

        emit("update:status", "billing"); // Inform parent if needed
      });
    });

    // Watch for state updates
    watch(
      () => [
        globalState.userName,
        globalState.userProfilePicture,
        globalState.availablePoints,
      ],
      ([newUserName, newUserProfilePicture, newAvailablePoints]) => {
        console.log("Watched updates in globalState:");
        console.log("New userName:", newUserName);
        console.log("New userProfilePicture:", newUserProfilePicture);
        console.log("New availablePoints:", newAvailablePoints);
      }
    );

    return {
      userName,
      userProfilePicture,
      availablePoints,
    };
  },
};
</script>

<style scoped>
img {
  object-fit: fill;
}
</style>
